
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.121 23.175c-6.875 0-12.448-5.573-12.448-12.449 0-3.942 1.835-7.453 4.694-9.734C8.914 1.27 2.956 7.397 2.956 14.919c0 7.698 6.241 13.939 13.94 13.939 4.99 0 9.364-2.623 11.827-6.566a12.393 12.393 0 01-4.602.883z","fill":"currentColor"}})])
          )
        }
      }
    